import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import Hero from './all/Hero';
import ServiceSection from './ServiceSection/ServiceSection';
import RoofingSection from './RoofingSection/RoofingSection';
import WorkGallery from './WorkGallery/WorkGallery';
import DublinRoofingSection from './DublinRoofingSection/DublinRoofingSection';
import CallbackSection from './all/Callbacksection';
import TestimonialSection from './TestimonialSection/TestimonialSection';
import MeetOurTeam from './MeetOurTeam/MeetOurTeam';
import WhyChooseUs from './WhyChooseUs/WhyChooseUs';
import Areas from './AreasWeServeAround/Areas';
import Faq from './FAQ/Faq';
import ContactCTA from './ContactCTA/ContactCTA';
import ResidentialRoofing from './ResidentialRoofing/ResidentialRoofing';
import ProblemsSection from './ProblemsSection/ProblemsSection';
import PortfolioSection from './PortfolioSection/PortfolioSection';
import RoofingProcess from './Process/RoofingProcess';
import EstimateForm from './EstimateForm/EstimateForm';
import { Helmet } from 'react-helmet';
// css files
import './all/Main.css';
import './SharedColumbusCss.css';


const MainLayout = () => {

  return (
    <div className='font-hauora'>
      <Helmet>
        <title>Top Commercial & Residential Roofing Contractor in Powell, Ohio | Ultimates Roofing</title>
        <link rel="canonical" href="https://www.ultimatesroofing.com/location/powell" />
        <meta
          name="description"
          content="Trusted roofing contractor in Powell, Ohio for residential & commercial roofs. GAF Master Elite® certified. TPO, EPDM, shingles, metal roofing, repairs, replacements, free inspections & 24/7 emergency service."
        />
        <meta
          name="Focus Keywords"
          content="Residential roofing company, Powell, Ohio, Small roofing company, Powell, Ohio, Best roofing company, Powell, Ohio, Powell Roofing Company, Affordable roofing company, Powell, Ohio, Roofing companies in Columbus, Ohio, Best roofing company in Columbus, Ohio, Roofing contractor Powell, Roofing Powell, Ohio, Roof repair, Powell, Ohio"
        />
        <meta name="author" content="Ultimates Roofing LLC" />
        <meta name="robots" content="index, follow" />
        <html lang="en" />
      </Helmet>
      
      <Hero></Hero>
      <CallbackSection></CallbackSection>
      <ServiceSection></ServiceSection>
      <ProblemsSection></ProblemsSection>

      <DublinRoofingSection></DublinRoofingSection>

      <ResidentialRoofing></ResidentialRoofing>

      <WorkGallery></WorkGallery>
      <RoofingSection></RoofingSection>
      <TestimonialSection></TestimonialSection>
      <RoofingProcess></RoofingProcess>

      <PortfolioSection></PortfolioSection>
      <WhyChooseUs></WhyChooseUs>
      <MeetOurTeam></MeetOurTeam>

      <Areas></Areas>
      <Faq></Faq>
      <ContactCTA></ContactCTA>

      <EstimateForm></EstimateForm>
    </div>
  );
};

export default MainLayout;

